import React, { useCallback, useEffect, useMemo } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  studyStatusHistoryReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./StudyStatusHistory.store";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import StudyStatusHistory from "../../library/StudyStatusHistory/StudyStatusHistory";
import { studyStatusOptions } from "../../../modules/constants";

export const SmartStudyStatusHistory = (props) => {
  const {
    studyEnrollmentID,
    onClose,
    searchedParams,
    totalItems,
    history,
    fetchStudyStatusHistory,
    resetState,
  } = props;

  const getData = useCallback(
    (searchParameters) => {
      if (studyEnrollmentID) {
        fetchStudyStatusHistory(studyEnrollmentID, searchParameters).catch(
          (error) => {
            sendNotification(error, ToastType.ERROR);
          }
        );
      }
    },
    [studyEnrollmentID, fetchStudyStatusHistory]
  );

  useEffect(() => {
    if (totalItems === null) {
      getData(searchedParams);
    }
  }, [getData, searchedParams, totalItems]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  return (
    <StudyStatusHistory
      onClose={onClose}
      getData={getData}
      searchedParams={searchedParams}
      totalitems={totalItems}
      history={history}
      studyStatuses={studyStatusOptions}
    />
  );
};

export default dynamic(
  "studyStatusHistoryReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(studyStatusHistoryReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartStudyStatusHistory));
